import { invoiceConstant } from "../constants/invoice.constant";

const initialState = {
  invoiceList: [],
  invoiceListStatus: 'IDLE',
  totalRecords: 0,
};

const InvoiceReducer = (state = initialState, action = '') => {
  const { type, payload } = action;
  switch (type) {
    case invoiceConstant.GET_INVOICE_LOOKUP_PENDING:
      return {
        ...state,
        invoiceListStatus: 'PENDING',
        invoiceList: [],
        totalRecords: 0,
      };
    case invoiceConstant.GET_INVOICE_LOOKUP_SUCCESS:
      return {
        ...state,
        invoiceListStatus: 'SUCCESS',
        invoiceList: payload.entityList,
        totalRecords: payload.totalRecords,
      };
    case invoiceConstant.GET_INVOICE_LOOKUP_FAILED:
      return {
        ...state,
        invoiceListStatus: 'FAILED',
        invoiceList: [],
        totalRecords: 0,
      };
    default:
      return state;
  }
};

export default InvoiceReducer;
